// src/config/tenant.js
export const tenantConfig = {
    'app.kurumsaldepo.com': {
        apiUrl: 'https://api.kurumsaldepo.com/api/',
        tenant: 'tenant1',
        siteName: "Kurumsal Depo"
    },
    'tenant2.kurumsaldepo.com': {
        apiUrl: 'https://apitest.kurumsaldepo.com/api/',
        tenant: 'tenant3',
        siteName: "Kurumsal Depo"
    },
    'app.bpartner.com.tr': {
        apiUrl: 'https://api.bpartner.com.tr/api/',
        tenant: 'bpartner',
        siteName: "Bpartner"
    }
};
//test

export const getTenantConfig = () => {
    const hostname = window.location.hostname;
    const isDevelopment = process.env.NODE_ENV === 'development';

    // console.log('Current hostname:', hostname);
    // console.log('Environment:', process.env.NODE_ENV);

    if (isDevelopment) {
        return {
            apiUrl: 'http://tenant1.localhost:8100/api/',
            tenant: 'tenant1',
            siteName: "Kurumsal Depo"
        };
    }

    return tenantConfig[hostname] || tenantConfig['tenant1.localhost'];
};

export const TenantService = {
    getCurrentTenant() {
        return getTenantConfig().tenant;
    },
    getCurrentTenantName() {
        return getTenantConfig().siteName;
    },
    getApiBaseUrl() {
        return getTenantConfig().apiUrl;
    }
};